"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useScrollToElement = void 0;
const react_1 = require("react");
const allDependenciesPresent = (dependencies) => dependencies.every((d) => !!d);
const useScrollToElement = (ref, { behavior = 'smooth', dependencies = [] }) => {
    (0, react_1.useEffect)(() => {
        var _a;
        if (allDependenciesPresent(dependencies)) {
            (_a = ref.current) === null || _a === void 0 ? void 0 : _a.scrollIntoView({
                behavior,
                block: 'center',
            });
        }
    }, [dependencies, ref, behavior]);
};
exports.useScrollToElement = useScrollToElement;
//# sourceMappingURL=index.js.map